import React from "react";

import { CameraList } from "../CameraList/CameraList";
import { StaticPager } from "../../../../components/Pager/Static/StaticPager";
import * as styles from "./staticCameraList.module.less";

export function StaticCameraList({
    baseUrl,
    lastPage,
    currentPage,
    staticPagedCameras,
    currency,
    sectionId
}) {
    return (
        <>
            {/* STATIC */}
            <CameraList items={staticPagedCameras} currency={currency} />
            <div className={styles.cameraListingPager}>
                <StaticPager
                    baseUrl={baseUrl}
                    lastPage={lastPage}
                    currentPage={currentPage}
                    urlFragment={sectionId}
                />
            </div>
        </>
    );
}
